import { w } from "windstitch";

export const Wrapper = w.section("lg:hidden w-full mt-[128px] my-[64px] ");

export const WrapperContent = w.div(
  "p-4"
);

export const SubTitle = w.h5(
  "font-roboto font-bold text-[20px] md:text-[32px] leading-[40px] tracking-[1px]"
);

export const Title = w.h1(
  "font-roboto font-black text-[32px] md:text-[64px] leading-[72px] tracking-[2px] text-left capitalize"
);

export const Text = w.p(
  "font-roboto mt-[20px] mb-[50px] font-normal text-[16px] leading-[24px] tracking-[1px] text-[14px] text-[16px]"
);

export const BtnBox = w.div("h-fit flex gap-[24px]");

export const Btn = w.button(
  "h-[48px] w-[171px] px-4 py-2 gap-2 rounded-[24px] flex items-center justify-center"
);

export const BtnOpportunityBox = w.div(
  "h-full relative flex justify-center items-end"
);

export const BtnOpportunity = w.button(
  " h-fit flex flex-col items-center gap-2 font-roboto font-bold text-[16px] leading-[24px] tracking-[1px] text-center capitalize"
);
